import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FryLogList() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_EXPRESS_URL}/api/admin/fry-logs`,
          { credentials: 'include' } // include the JWT cookie
        );

        if (!res.ok) throw new Error('Unauthorized or server error');
        const data = await res.json();
        setLogs(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  if (loading) return <p className="text-center mt-8">Loading fry logs...</p>;

  return (
    <div className="w-full">
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2">
        {logs.map((log) => (
          <div
            key={log.id}
            onClick={() => navigate(`/admin/dashboard/edit/${log.id}`)}
            className="p-4 bg-white dark:bg-gray-800 border border-pink-200 dark:border-gray-700 rounded-lg shadow hover:shadow-lg cursor-pointer transition"
          >
            <h3 className="text-xl font-semibold text-pink-700 dark:text-pink-300 mb-1">
              {log.title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              📅 {new Date(log.date).toLocaleDateString()}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              💪 Kneading: {log.kneading_time || '—'} min • ⏲️ 1st Rise:{' '}
              {log.first_rise_time || '—'} min • ⏱️ 2nd Rise: {log.second_rise_time || '—'} min
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              🍩 Size: {log.donut_size || '—'} • 🌡️ Oil Temp: {log.oil_temp || '—'}°C
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              ❄️ Fridge Wait: {log.wait_after_fridge || '—'} min
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">⭐ Rating: {log.rating}/10</p>
          </div>
        ))}
      </div>
    </div>
  );
}
